import React from 'react'

const Footer = () => {
  return (
    <div className='md:p-3 bg-[#252525] flex justify-center items-center h-[10vh] text-[#AAAAAA]'>
        <p>Ⓒ 2022 #VANLIFE</p>
    </div>
  )
}

export default Footer